import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ROW_TYPES } from '../row-types';
import { Row } from 'src/app/components/form-creation/form-creator/row';
import { BaseComponent } from 'src/app/components/base.component';
import { SharedService } from 'src/app/services/sharedService';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'rdf-row-editor',
  templateUrl: './row-editor.component.html',
  styleUrls: ['./row-editor.component.css']
})
export class RowEditorComponent extends BaseComponent implements OnInit {
  rowTypes = ROW_TYPES
  @Input() row
  @Input() col
  @Input() emittables
  originalRow: any
  selectableList = false
  editableDropdown = true
  @Output() onCancelEditing = new EventEmitter()
  @Output() onCreateRow = new EventEmitter()
  errors
  existingRow = false
  constructor(private sharedService: SharedService) {
    super()
  }

  ngOnInit() {
    if (!this.row) {
      this.row = new Row()
    } else {
      this.existingRow = true
    }
    this.sharedService.rowCreationErrorSubject$.pipe(takeUntil(this.destroy$)).subscribe(errors => {
      this.errors = errors
    })
    this.originalRow = Object.assign({}, this.row)
    this.selectableList = this.isSelectable(this.row.type)
  }

  setListItems(items) {
    this.row['selectItems'] = items
  }

  checkRowType(val) {
    this.selectableList = this.isSelectable(val)
  }

  isSelectable(val) {
    if (['dropdown', 'multiselect', 'option'].includes(this.row.type) || this.row.type.includes(' CONF-DR')) {
      return true;
    }
    return false
  }

  cancelEditing() {
    this.onCancelEditing.emit()
  }

  createRow() {
    this.onCreateRow.emit(this.row)
  }

  isValid() {
    return this.row.type
  }

  setCustomValue(event, col = null) {
    if (col) {
      if (!this.row['customValueEmitter'])
        this.row['customValueEmitter'] = []
      event['localColumn'] = col.key
      this.row['customValueEmitter'] = this.row['customValueEmitter'].filter(elem => elem.localColumn !== col.key)
      this.row['customValueEmitter'].push(event)
    } else
      this.row['customValueEmitter'] = event
  }
}
